<template>
  <LayoutAdmin>
    <section class="w-full px-4 mt-6 md:px-8">
      <section class="flex justify-between">
        <h1 class="text-lg md:text-2xl">
          Employee Detail |
          <router-link to="/employee" class="text-sm text-primary">Back to all employee</router-link>
        </h1>
      </section>
      <section class="relative w-full h-full bg-white">
        <section class="grid w-full bg-white shadow-md md:h-64" v-if="loading">
          <Loading />
        </section>
        <section v-else class="grid w-full h-full gap-3 py-3 my-6 bg-white shadow-md md:grid-cols-2 lg:grid-cols-3">
          <section class="flex flex-col items-center px-6 md:flex-row md:items-start">
            <div @click="openFilePicker"
              class="relative flex items-center justify-center w-32 h-32 overflow-hidden rounded-full cursor-pointer bg-zinc-400">
              <h2 class="text-3xl text-white" v-if="!personal_detail?.emp_profile && !blobImgUrl">
                {{
                  personal_detail?.emp_fullname.substr(0, 1) +
                  personal_detail?.emp_fullname.substr(
                    personal_detail?.emp_fullname.indexOf(" ") + 1,
                    1
                  )
                }}
              </h2>
              <img v-else :src="blobImgUrl
                ? blobImgUrl
                : `${urlImageServer}/${personal_detail.emp_profile}`
                " alt="profile image" class="w-full h-full cursor-pointer profile" />
              <div class="absolute bottom-0 left-0 w-full py-1 text-sm text-center text-white duration-300 opacity-0">
                Change
              </div>
              <input ref="fileInput" type="file" class="hidden" @change="changeImage" />
            </div>
            <div class="ml-0 text-center md:ml-9 md:text-start">
              <section class="h-[160px]">
                <h1 class="text-base text-left md:text-xl">
                  {{ personal_detail?.emp_fullname }}
                </h1>
                <Button class="px-4 py-1 my-2 text-sm text-white rounded-full"
                  :style="`background:${employment?.emp_status?.empstatus_color}`">
                  {{ employment?.emp_status?.empstatus_name }}
                </Button>
                <p class="text-sm text-left text-gray-400">
                  {{ employment.emp_desid?.des_name }}
                </p>
                <p class="text-sm text-left text-gray-400"></p>
                <p class="text-sm text-left text-gray-400">
                  {{ employment.emp_depid?.dep_name }}
                </p>
              </section>
              <p class="my-1 text-sm text-left text-primary">
                Employment Status
              </p>
              <SwitchButton :value="employment?.emp_employment_status" class="w-max" @update:model="(value) => handleUpdateStatus(value, 'emp_employment_status')
              " />
            </div>
          </section>
          <section class="mb-6 h-max">
            <section class="md:border-x h-[160px] px-6 py-4">
              <div class="flex items-center mb-4">
                <font-awesome-icon icon="fa-briefcase" class="w-10 text-2xl text-primary" />
                <div class="ml-3">
                  <p class="text-sm text-gray-400">Departemen</p>
                  <p class="text-sm opacity-80">
                    {{ employment.emp_depid?.dep_name }}
                  </p>
                </div>
              </div>
              <div class="flex items-center">
                <font-awesome-icon icon="fa-clock" class="w-10 text-2xl text-primary" />
                <div class="ml-3">
                  <p class="text-sm text-gray-400">Work Shifts</p>
                  <p class="text-sm opacity-80">
                    {{ employment.emp_depid?.dep_workshift }}
                  </p>
                </div>
              </div>
            </section>
            <section class="px-8">
              <p class="my-1 text-sm text-primary">Attendance Status</p>
              <SwitchButton :value="employment?.emp_attendance_status" class="w-max" @update:model="(value) => handleUpdateStatus(value, 'emp_attendance_status')
              " />
            </section>
            <section class="px-6 md:py-4 md:hidden">
              <section class="h-[160px]">
                <div class="flex items-center mb-5">
                  <font-awesome-icon icon="fa-dollar" class="w-10 text-2xl text-primary" />
                  <div class="ml-3">
                    <p class="text-sm text-gray-400">Salary</p>
                    <p class="text-sm opacity-80">
                      $ 10,000
                      <span class="text-xs text-primary">(current)</span>
                    </p>
                  </div>
                </div>
                <div class="flex items-center">
                  <font-awesome-icon icon="fa-calendar" class="w-10 text-2xl text-primary" />
                  <div class="ml-3">
                    <p class="text-sm text-gray-400">Joining date</p>
                    <p class="text-sm opacity-80">Not added yet</p>
                  </div>
                </div>
              </section>
              <section class="px-8">
                <p class="my-1 text-sm text-primary">Payroll Status</p>
                <SwitchButton :value="employment?.emp_payroll_status" class="w-max" @update:model="(value) => handleUpdateStatus(value, 'emp_payroll_status')
                " />
              </section>
            </section>
          </section>
          <section class="hidden px-6 md:block">
            <section class="h-[160px] py-4">
              <div class="flex items-center mb-4">
                <font-awesome-icon icon="fa-dollar" class="w-10 text-2xl text-primary" />
                <div class="ml-3">
                  <p class="text-sm text-gray-400">Salary</p>
                  <p class="text-sm opacity-80">
                    $ 10,000
                    <span class="text-xs text-primary">(current)</span>
                  </p>
                </div>
              </div>
              <div class="flex items-center">
                <font-awesome-icon icon="fa-calendar" class="w-10 text-2xl text-primary" />
                <div class="ml-3">
                  <p class="text-sm text-gray-400">Joining date</p>
                  <p class="text-sm opacity-80">Not added yet</p>
                </div>
              </div>
            </section>
            <section class="px-8">
              <p class="my-1 text-sm text-primary">Payroll Status</p>
              <SwitchButton :value="employment?.emp_payroll_status" class="w-max" @update:model="(value) => handleUpdateStatus(value, 'emp_payroll_status')
              " />
            </section>
            <section class="px-8">
              <p class="my-1 text-sm text-primary">Payrun type</p>
              <select class="w-full border focus:outline focus:outline-primary px-3 py-1.5 bg-white rounded-md text-sm"
                v-model="payrunType" @change="savePayrunType">
                <option :value="null">Selected payrun type</option>
                <option v-for="(payrunType, i) in payrunTypes" :key="i" class="px-2 py-1" :value="payrunType._id">
                  {{ payrunType.payrun_type }}
                </option>
              </select>
            </section>
          </section>
        </section>
      </section>

      <section class="flex flex-col justify-between w-full h-auto mb-6 md:flex-row">
        <section class="mb-6 text-center bg-white shadow-md md:w-1/5">
          <font-awesome-icon icon="fa-user" class="my-10 text-2xl text-primary" />
          <ul class="text-left">
            <!-- <li class="w-full px-4 mb-4 text-sm truncate cursor-pointer" v-for="(title, i) in titleTabs" :class="sideTabActive === title.name ? 'text-primary' : 'text-gray-400'
              " @click="sideTabActive = title.name" :key="i">
              <font-awesome-icon :icon="title.icon" class="w-4 h-4 mr-2" />
              {{ title.name }}
            </li> -->
            <template v-for="(title, i) in titleTabs" :key="i">
              <li v-if="!(title.name === 'Payroll' && this.role === 'Staff')"
                class="w-full px-4 mb-4 text-sm truncate cursor-pointer"
                :class="sideTabActive === title.name ? 'text-primary' : 'text-gray-400'"
                @click="sideTabActive = title.name">
                <font-awesome-icon :icon="title.icon" class="w-4 h-4 mr-2" />
                {{ title.name }}
              </li>
            </template>
          </ul>
        </section>
        <section class="w-full bg-white md:w-3/4">
          <PersonalDetail v-if="sideTabActive === 'Personal Detail'" :personalDetail="personal_detail"
            :handleDetailEmployment="handleDetailEmployment.bind(this)" />
          <Employement v-if="sideTabActive === 'Employment'" :employment="employment"
            :handleDetailEmployment="handleDetailEmployment.bind(this)" />
          <Experience v-if="sideTabActive === 'Pendidikan dan Pengalaman'" />
          <Rekening v-if="sideTabActive === 'Rekening'" />
          <Payroll v-if="sideTabActive === 'Payroll'" />
          <Cuti v-if="sideTabActive === 'Cuti'" :cuti-detail="cuti"
            :handleDetailEmployment="handleDetailEmployment.bind(this)" />
          <ResetPassword v-if="sideTabActive === 'Reset Password'" :employment="personal_detail?.emp_fullname" />
        </section>
      </section>
    </section>
  </LayoutAdmin>
</template>

<script>
import LayoutAdmin from "../../components/Layout/Admin.vue";
import PersonalDetail from "../../components/PersonalDetail.vue";
import Loading from "../../components/Loading.vue";
import Employement from "../../components/Employement.vue";
import Experience from "../../components/Education.vue";
import Rekening from "../../components/Rekening.vue";
import ResetPassword from "../../components/ResetPassword.vue";
import Payroll from "../../components/Payroll.vue";
import SwitchButton from "../../components/SwitchButton.vue";
import Cuti from "../../components/Cuti.vue";
import {
  DetailEmployementAPI,
  UpdateProfileAPI,
  EditStatusEmployementAPI,
} from "@/actions/employment";
import { getPayrunTypes, savePayrunTypeEmployee } from "@/actions/payruntype";
import { URL_IMAGES } from "@/config";
import { useToast } from "vue-toastification";

import Button from "@/components/Button.vue";
import decryptToken from "@/utils/decryptToken";
export default {
  name: "DetailEmployee",
  components: {
    LayoutAdmin,
    Button,
    PersonalDetail,
    Employement,
    Experience,
    Rekening,
    Payroll,
    Cuti,
    Loading,
    SwitchButton,
    ResetPassword,
  },
  setup() {
    const toast = useToast();
    return {
      getPayrunTypes,
      savePayrunTypeEmployee,
      toast,
    };
  },
  data() {
    return {
      contents: [
        {
          text: "Payrun",
          to: "/payroll-run",
        },
        { text: "Payslip", to: "/payroll-slip" },
        { text: "Summary", to: "/payroll-summary" },
        { text: "Beneficiary badge", to: "/payroll-beneficiary" },
      ],
      titleTabs: [
        { name: "Personal Detail", icon: "fa-user" },
        { name: "Employment", icon: "fa-user-tie" },
        { name: "Pendidikan dan Pengalaman", icon: "fa-graduation-cap" },
        { name: "Rekening", icon: "fa-credit-card" },
        { name: "Payroll", icon: "fa-dollar" },
        { name: "Cuti", icon: "fa-calendar" },
        { name: "Reset Password", icon: "fa-lock" },
      ],
      isOpenAccordion: false,
      loading: true,
      role: "",
      urlImageServer: URL_IMAGES,
      blobImgUrl: "",
      sideTabActive: "Personal Detail",
      personal_detail: {
        emp_firstname: "",
        emp_lastname: "",
        email: "",
        emp_nikktp: "",
        emp_phone: "",
        emp_profile: "",
        emp_marital_status: "",
        emp_gender: "",
        emp_fullname: "",
        emp_blood: "",
        company_id: "",
        payrun_type: null,
      },
      employment: {
        emp_status: "",
        username: "",
        emp_nik_karyawan: "",
        emp_depid: {},
        emp_desid: {},
        emp_fsuperior: "",
        emp_ssuperior: "",
        emp_hr: "",
        emp_location: "",
        emp_tanggungan: "",
        emp_attadance: {},
        company_id: "",
        emp_attendance_status: true,
        emp_employment_status: true,
        emp_payroll_status: true,
      },
      cuti: {
        amount: 0,
      },
      payrunTypes: [],
      payrunType: null,
    };
  },
  methods: {
    openFilePicker() {
      this.$refs.fileInput.click();
    },
    async handleUpdateStatus(value, key) {
      this.employment[key] = value;
      const { id } = this.$route.params;
      const response = await EditStatusEmployementAPI(id, { [key]: value });
      if (response?.status === 401) {
        return this.$router.push("/login");
      }
      this.loading = false;
    },
    async changeImage(event) {
      const file = event.target.files[0];
      const blobImage = URL.createObjectURL(file);
      this.blobImgUrl = blobImage;

      const fd = new FormData();
      fd.append("profile", file);
      await UpdateProfileAPI(this.$route.params.id, fd);
    },
    handleAssignPersonalData(data) {
      this.personal_detail.emp_firstname = data?.emp_firstname;
      this.personal_detail.emp_lastname = data?.emp_lastname;
      this.personal_detail.emp_fullname = data?.emp_fullname;
      this.personal_detail.email = data?.email;
      this.personal_detail.emp_nikktp = data?.emp_nikktp;
      this.personal_detail.emp_gender = data?.emp_gender;
      this.personal_detail.emp_marital_status = data?.emp_marital_status;
      this.personal_detail.emp_birthday = data?.emp_birthday;
      this.personal_detail.emp_status = data?.emp_status;
      this.personal_detail.emp_phone = data?.emp_phone;
      this.personal_detail.emp_profile = data?.emp_profile;
      this.personal_detail.emp_blood = data?.emp_blood;
      this.personal_detail.company_id = data?.company_id?._id;
      this.payrunType = data?.payrun_type;
      this.getPayrunType(data.company_id._id);
    },
    handleAssignEmploymentData(data) {
      const { employment } = this;
      employment.emp_status = data?.emp_status;
      employment.username = data?.username;
      employment.emp_nik_karyawan = data?.emp_nik_karyawan;
      employment.emp_depid = data?.emp_depid;
      employment.emp_desid = data?.emp_desid;
      employment.emp_fsuperior = data?.emp_fsuperior;
      employment.emp_ssuperior = data?.emp_ssuperior;
      employment.emp_hr = data?.emp_hr;
      employment.emp_location = data?.emp_location;
      employment.emp_attadance = data?.emp_attadance;
      employment.emp_tanggungan = data?.emp_tanggungan;
      employment.company_id = data?.company_id?._id;
      employment.emp_attendance_status = data?.emp_attendance_status;
      employment.emp_payroll_status = data?.emp_payroll_status;
      employment.emp_employment_status = data?.emp_employment_status;
    },
    async handleDetailEmployment() {
      const { id } = this.$route.params;
      const response = await DetailEmployementAPI(id);
      const data = response?.data;
      if (response?.status === 401) {
        return this.$router.push("/login");
      }
      this.handleAssignPersonalData(data);
      this.handleAssignEmploymentData(data);
      this.cuti.amount = data.emp_leave_token ?? 0;
      this.loading = false;
    },
    async getPayrunType(companyId) {
      const { data, success, code, message } = await getPayrunTypes(companyId);

      if (success) {
        this.payrunTypes = data;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    async savePayrunType() {
      const { id } = this.$route.params;
      if (this.payrunType !== null) {
        this.loading = true;

        const { success, message } = await savePayrunTypeEmployee({
          id,
          payrunType: this.payrunType,
        });
        this.loading = false;
        if (success) {
          this.toast.success("updated payrun type");
        } else {
          this.toast.error(message);
        }
      }
    },
  },
  mounted() {
    this.handleDetailEmployment();
    const payload = decryptToken();
    this.role = payload?.role;
  },
};
</script>

<style scoped>
.profile {
  min-width: 128px;
  min-height: 128px;
}

.profile:hover~.absolute {
  background-color: rgba(0, 0, 0, 0.6) !important;
  opacity: 1 !important;
  transition: 0.3s;
}
</style>
